import { useCallback } from 'react'
import {
  AREA_LIST_STATS_MAX_SIZE,
  isDefined,
  isEmpty,
  isNotDefined,
  type AreaData,
  type AreaListInput,
  type AreaListSuccess,
} from '@terros/common'
import { useServerRequest } from '../api'

const AREA_LIST_ALL_PAGES_SIZE = 1000

export const fetchAllAreaPages = async ({
  input,
  fetchPage,
}: {
  input: AreaListInput
  fetchPage: (input: AreaListInput) => Promise<AreaListSuccess>
}): Promise<AreaData[]> => {
  const areas: AreaData[] = []
  let sortTimestamp = input.sortTimestamp

  while (true) {
    // oxlint-disable-next-line no-await-in-loop -- each page cursor depends on the previous response
    const page = await fetchPage({
      ...input,
      version: 2,
      size: isEmpty(input.stats) ? AREA_LIST_ALL_PAGES_SIZE : AREA_LIST_STATS_MAX_SIZE,
      sortTimestamp,
    })
    areas.push(...page.areas)
    if (isEmpty(page.areas)) break
    if (isNotDefined(page.sortTimestamp)) break
    if (isDefined(page.total) && areas.length >= page.total) break
    sortTimestamp = page.sortTimestamp
  }

  return areas
}

export function useFetchAllAreas(): (input: AreaListInput) => Promise<AreaData[]> {
  const serverRequest = useServerRequest<AreaListInput, AreaListSuccess>('/area/list')
  return useCallback(
    (input: AreaListInput): Promise<AreaData[]> => fetchAllAreaPages({ input, fetchPage: serverRequest }),
    [serverRequest]
  )
}
